import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { PublicRoutingModule } from './public-routing.component';
import { HomeComponent } from './home/home.component';
import { SpecificationsComponent } from './specifications/specifications.component';
import { Ng5SliderModule } from 'ng5-slider';
import { NgSelect2Module } from 'ng-select2';
import { BudgetPreviewComponent } from './budget-preview/budget-preview.component';
import { ComunModule } from '../../comun.module';
import { OperationModalComponent } from './budget-preview/operation-modal/operation-modal.component';
import { HeadercontentComponent } from './shared/headercontent/headercontent.component';
import { CupraCareComponent } from './budget-preview/cupra-care/cupra-care.component';
import { CupraCareFormComponent } from './cupra-care-form/cupra-care-form.component';
import { CupraDateFormComponent  } from './cupra-date-form/cupra-date-form.component';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { PiezaDesgasteModalComponent } from './budget-preview/pieza-desgaste-modal/pieza-desgaste-modal.component';
import { BudgetSummaryComponent } from '../shared/budget-summary/budget-summary.component';
import { PoliticaCookiesComponent } from './politica-cookies/politica-cookies.component';

@NgModule({
  imports: [    
    PublicRoutingModule,
    CommonModule,
    NgbModule,
    FormsModule,
    Ng5SliderModule,
    ReactiveFormsModule,
    NgSelect2Module,
    SlickCarouselModule,
    ComunModule
  ],
  declarations: [
    HomeComponent,
    SpecificationsComponent,
    BudgetPreviewComponent,
    OperationModalComponent,
    PiezaDesgasteModalComponent,
    CupraCareComponent,
    HeadercontentComponent,
    CupraCareFormComponent,
    CupraDateFormComponent,
    PoliticaCookiesComponent
  ],
  entryComponents: [
    OperationModalComponent,
    PiezaDesgasteModalComponent
  ]
})
export class PublicModule {
 }
    
